module.exports = __webpack_public_path__ + "img/cat-04-in.ce26b138.svg";